import { EditableText } from '@smartfire/components';
import {
    BlockWrapper, defineBlock,
    smartProps,
    useInspectorControl
} from '@smartfire/js-block-engine';
import { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Logo } from '../assets/logo.svg';
import style from './style.module.scss';

const Inspector = lazy(() => import('./inspector'));

const Footer = ({ menu, policyLink, mentionLink, email, tel }) => {
    const { t } = useTranslation();
    useInspectorControl(Inspector);

    const [loading, setLoading] = useState(false);
    const [emailNewsletter, setEmailNewsletter] = useState(null);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const sendNewsletter = (e) => {
        e.preventDefault();
        setLoading(true);
        
        fetch('/wp-json/smartfire/v1/newsletter', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: emailNewsletter })
        })
        .then(response => response.json())
        .then(data => {
            setLoading(false);
            setEmailNewsletter('');
            setSuccess(data.success);
            setError(data.error);
        });
    }

    return (
        <BlockWrapper.Footer className={style.block}>
            <div className={style.footer}>
                <div className={style.newsletterPart}>
                    <form className={style.newsletterForm} onSubmit={sendNewsletter}>
                        <input size="40" placeholder={t("Recevoir la newsletter")} value={emailNewsletter} type="text" required onChange={event => setEmailNewsletter(event.target.value)}/>
                        <input type="submit" class="btn btn-valide-charte" value={t("Envoyer")} disabled={loading}></input>
                    </form>
                    {success && <p className={style.success}>Merci pour votre inscription!</p>}
                    {error && <p className={style.error}>{error}</p>}
                </div>
                <div className={style.infosmenu}>
                    <div className={style.infos}>
                        <Logo />
                        <EditableText smartProp="name" tagName="p" />
                        <EditableText smartProp="addresse" tagName="p" />
                        <EditableText
                            smartProp="tel"
                            tagName="a"
                            tagProps={{ href: 'tel:' + tel }}
                        />
                        <EditableText
                            smartProp="email"
                            tagName="a"
                            tagProps={{ href: 'mailto:' + email }}
                        />
                    </div>
                    {menu &&
                        menu.map((group, i) => (
                            <div key={i} className={style.group}>
                                <p className={style.groupTitle}>{group.title}</p>
                                {group.children.length &&
                                    group.children.map((el, i) => (
                                        <a key={i} href={el.url} className={style.link}>
                                            {el.title}
                                        </a>
                                    ))}
                            </div>
                        ))}
                </div>
            </div>
            <div className={style.subFooter}>
                <a href={mentionLink}>Mentions légales</a>
                <div className={style.dot} />
                <a href={policyLink}>Politique de confidentialité</a>
            </div>
        </BlockWrapper.Footer>
    );
};

export default defineBlock({
    Block: Footer,
    smartProps: {
        infos: smartProps.string.withDefault(''),
        mentionLink: smartProps.string.withDefault(''),
        policyLink: smartProps.string.withDefault(''),
        name: smartProps.string.withDefault(''),
        addresse: smartProps.string.withDefault(''),
        tel: smartProps.string.withDefault(''),
        email: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Footer',
    },
});
